import { render, staticRenderFns } from "./viewings-page.vue?vue&type=template&id=0fbd0ee4&scoped=true&"
import script from "./viewings-page.vue?vue&type=script&lang=js&"
export * from "./viewings-page.vue?vue&type=script&lang=js&"
import style0 from "./viewings-page.vue?vue&type=style&index=0&id=0fbd0ee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd0ee4",
  null
  
)

export default component.exports